<div class="app-footer">

  <ng-container *ngTemplateOutlet="partnerTemplate; context: { sponsors: viewModel.sponsors, slides: sponsors, flickityOptions: sponsorOptions }"></ng-container>
  <ng-container *ngTemplateOutlet="partnerTemplate; context: { sponsors: viewModel.partners, slides: partners, flickityOptions: partnerOptions }"></ng-container>

  <div class="bottom">

    <div class="column-1">
      <div class="app-footer__logo">
        <a routerLink="/"></a>
      </div>
      <div *ngIf="viewModel.copyright"
           class="app-footer__copyright">
        <span>{{viewModel.copyright}}</span>
      </div>

      <ng-container *ngTemplateOutlet="socialTemplate"></ng-container>
    </div>

    <div class="column-2">
      <div *ngIf="footerNavigation"
           class="app-footer__site-links">

        <div *ngFor="let item of footerNavigation; let i = index"
             [class.submenu]="item.child_items?.length > 0"
             class="item {{item.css_class}}">
          <amg-link [path]="item.url"
                    [text]="item.title"
                    class="link">
          </amg-link>


          <ng-container *ngIf="item.child_items?.length > 0 && item.classes.includes('teams-menu')">
            <ul
              class="submenu__container">
              <li *ngFor="let subItem of item.child_items">
                <app-team-box [menuItem]="subItem"
                              [team]="getTeam(subItem.slug)"
                              [teamsPath]="wpCommonData.pages.team"
                ></app-team-box>
              </li>
            </ul>
          </ng-container>
        </div>
      </div>

      <ng-container *ngTemplateOutlet="socialTemplate"></ng-container>
    </div>

    <!--  <div class="column-3">
        <div class="app-footer__signup"></div>
      </div>-->
  </div>

  <div *ngIf="footerBottomLinks"
       class="app-footer__bottom-links">
    <ng-container *ngFor="let item of footerBottomLinks">
      <amg-link [path]="item.url"
                class="link">{{item.title}}</amg-link>
      <span>&nbsp;</span>
    </ng-container>
  </div>

  <ng-template #partnerTemplate
               let-flickityOptions="flickityOptions"
               let-slides="slides"
               let-sponsors="sponsors">
    <div *ngIf="sponsors"
         class="app-footer__partners">
      <h3>{{sponsors.title}}</h3>
      <div class="app-footer__partners-links">

        <amg-carousel *ngIf="slides"
                      [flickityOptions]="flickityOptions">
          <div *ngFor="let pane of slides"
               class="pane">
            <a *ngFor="let sponsor of pane"
               [href]="sponsor.link"
               target="_blank">
              <amg-image [src]="sponsor.image?.sizes?.thumbnail?.url"></amg-image>
            </a>
          </div>
        </amg-carousel>

      </div>
    </div>
  </ng-template>
  <ng-template #socialTemplate>
    <div *ngIf="socialMenu"
         class="app-footer__social">
      <h3>{{socialMenu.acf.title}}</h3>
      <div class="app-footer__social-links">
        <ng-container *ngFor="let site of socialMenu.items">
          <a *ngIf="site.url"
             [href]="site.url"
             [title]="site.title"
             class="app-footer__social-links-anchor"
             target="_blank">

            <span class="social-icon"></span>

          </a>
        </ng-container>

      </div>
    </div>
  </ng-template>
</div>
